import globalClasses from 'styles/globalStyle.module.scss';

const SkipLink = () => {
  return (
    <a href="#main-content" className={globalClasses.skipLink}>
      Skip to main content
    </a>
  );
};

export default SkipLink;
